import React from 'react';
import Icon from '../../../components/AppIcon';
import { motion } from 'framer-motion';

const ExperienceStats = ({ experiences }) => {
  const totalYears = experiences.reduce((total, exp) => {
    const years = parseFloat(exp.duration.match(/(\d+\.?\d*)\s*year/)?.[1] || 0);
    return total + years;
  }, 0);

  const totalProjects = experiences.reduce((total, exp) => total + (exp.projectsCompleted || 0), 0);
  
  const uniqueTechnologies = [...new Set(experiences.flatMap(exp => exp.technologies))].length;
  
  const companiesWorked = experiences.length;

  const stats = [
    {
      icon: 'Clock',
      value: `${3}+`,
      label: 'Years Experience',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      borderColor: 'border-primary/20'
    },
    {
      icon: 'FolderOpen',
      value: `${30}+`,
      label: 'Projects Completed',
      color: 'text-success',
      bgColor: 'bg-success/10',
      borderColor: 'border-success/20'
    },
    {
      icon: 'Code',
      value: `${10}+`,
      label: 'Technologies Used',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      borderColor: 'border-accent/20'
    },
    {
      icon: 'Building',
      value: `${companiesWorked}`,
      label: 'Companies Worked',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
      borderColor: 'border-secondary/20'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {stats.map((stat, index) => (
        <motion.div
          key={stat.label}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          className={`bg-surface rounded-lg border ${stat.borderColor} p-6 text-center hover:shadow-md transition-all duration-300`}
        >
          <div className={`w-12 h-12 ${stat.bgColor} rounded-lg flex items-center justify-center mx-auto mb-4`}>
            <Icon name={stat.icon} size={24} className={stat.color} />
          </div>
          <div className={`text-2xl font-bold ${stat.color} mb-1`}>
            {stat.value}
          </div>
          <div className="text-sm text-text-secondary">
            {stat.label}
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default ExperienceStats;